document.addEventListener('click', function (event) {
  const clickedHeader = event.target.closest(
    'summary, .accordion__summary, .collapsible-row__button'
  );

  if (!clickedHeader) return;

  const clickedTab = clickedHeader.closest('details, .accordion, .collapsible-row');
  const productInfo = clickedHeader.closest(
    '.product__info-container, .product-info, [data-product-info]'
  );

  if (!clickedTab || !productInfo) return;

  productInfo
    .querySelectorAll('details[open], .accordion.is-open, .collapsible-row.is-open')
    .forEach(function (tab) {
      if (tab === clickedTab) return;

      if (tab.tagName === 'DETAILS') {
        tab.removeAttribute('open');
      }

      tab.classList.remove('is-open', 'active', 'open');

      const button = tab.querySelector('[aria-expanded="true"]');
      if (button) {
        button.setAttribute('aria-expanded', 'false');
      }
    });
});